export const menu = {
  NaviMenu: "메인 메뉴",
  Home: "홈",
  Friends: "친구",
  Chats: "대화",
  Notes: "노트",
  Play: "놀이",
  Etc: "기타",
  Favorites: "즐겨찾기",
  UserMenu: "유저 메뉴",
  Emoji: "이모지",
  Sticker: "스티커",
  GIF: "GIF",
} as const;
